import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { MobileScreen } from "@/components/revanche/MobileScreen";
import { API } from "@/lib/api";

const Login = () => {
    const navigate = useNavigate();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        // Déjà connecté ? On saute l'écran.
        fetch(`${API}/auth/me`, { credentials: "include" })
            .then((r) => {
                if (r.ok) navigate("/analyse-terminee");
                else setChecking(false);
            })
            .catch(() => setChecking(false));
    }, [navigate]);

    const startGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/analyse-terminee";
        window.location.href =
            "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
    };

    if (checking) return <div className="fixed inset-0 bg-black" />;

    const footer = (
        <PrimaryCTA dataTestId="btn-google-login" onClick={startGoogle}>
            Continuer avec Google
        </PrimaryCTA>
    );

    return (
        <MobileScreen footer={footer} dataTestId="login-screen">
            <div className="flex-1 flex flex-col justify-center gap-4">
                <h2
                    className="font-display font-black uppercase text-white leading-[0.95] tracking-tight"
                    style={{ fontSize: "clamp(30px, 9vw, 44px)" }}
                >
                    Crée ton compte pour voir ton analyse.
                </h2>
                <p className="text-base text-white max-w-[320px]">
                    On enregistre tes réponses et on débloque ton résultat.
                </p>
            </div>
        </MobileScreen>
    );
};

export default Login;
